export default {
	methods: {
		addTotalHTAndRefac(purchase){
			let total = purchase.recurrence > 0 ? purchase.recurrence_price : purchase.price;
			let refac = 0;
			if(purchase.is_billable == 1){
				refac = purchase.sell_price || 0;
				/*
				 * refac = purchase.recurrence > 0 ? purchase.recurrence_price : purchase.price
				 * if(purchase.margin_price > 0) refac += purchase.margin_price
				 * if(purchase.margin_rate > 0) refac += (total * (purchase.margin_rate / 100))
				 */
			}
			else{
				refac = 0;
			}
			let retTotal = Number.parseFloat(total.toFixed(2));
			let retRefac = Number.parseFloat(refac.toFixed(2));
			return {"total": retTotal, "refac": retRefac};
		},
	}
};